import { AlertTriangle, RefreshCw, Send, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApp } from "@/lib/i18n";

const REASON = {
  ended: ["Mikrofon terputus atau perkongsian audio dihentikan.", "Microphone disconnected or audio sharing stopped."],
  muted: ["Mikrofon diambil oleh aplikasi lain (contohnya panggilan masuk).", "Microphone was taken by another app (e.g. an incoming call)."],
  interrupted: ["Audio telefon diganggu oleh sistem (panggilan, Siri atau skrin dikunci).", "Phone audio was interrupted by the system (call, Siri or screen lock)."],
};

export const InterruptBanner = ({ lost, gap, onReconnect, onSend, onDismiss }) => {
  const { L } = useApp();
  if (!lost && gap < 5) return null;
  const mins = gap >= 90 ? L(`${Math.round(gap / 60)} minit`, `${Math.round(gap / 60)} min`) : L(`${Math.round(gap)} saat`, `${Math.round(gap)} s`);
  return (
    <div className="mt-4 rounded-xl border-2 border-red-300 bg-red-50 p-4 text-sm text-red-900" role="alert" data-testid="recording-interrupted">
      <div className="flex items-start gap-2">
        <AlertTriangle size={18} className="mt-0.5 shrink-0 text-red-600" />
        <div className="min-w-0 flex-1">
          <p className="font-bold">{lost ? L("Rakaman terhenti!", "Recording stopped!") : L(`Rakaman terhenti selama ${mins}`, `Recording stopped for ${mins}`)}</p>
          <p className="mt-0.5 text-red-800">
            {lost ? L(...REASON[lost.reason]) : L("Telefon dikunci atau aplikasi ditukar, jadi bahagian ini tidak dirakam. Rakaman kini bersambung semula.", "The phone was locked or you switched apps, so this part wasn't recorded. Recording has resumed.")}
            {lost && gap >= 5 && ` ${L(`Kira-kira ${mins} tidak dirakam.`, `About ${mins} was not recorded.`)}`}
            {" "}{L("Bahagian sebelumnya selamat disimpan.", "Everything before is saved.")}
          </p>
        </div>
        {!lost && <button onClick={onDismiss} aria-label={L("Tutup", "Dismiss")} className="text-red-500 hover:text-red-700" data-testid="interrupt-dismiss-btn"><X size={16} /></button>}
      </div>
      {lost && (
        <div className="mt-3 flex flex-wrap gap-2">
          <Button size="sm" onClick={onReconnect} className="rounded-xl bg-red-600 hover:bg-red-700" data-testid="interrupt-reconnect-btn"><RefreshCw size={14} className="mr-1" /> {L("Sambung rakam", "Resume recording")}</Button>
          <Button size="sm" variant="outline" onClick={onSend} className="rounded-xl border-red-300 bg-white" data-testid="interrupt-send-btn"><Send size={14} className="mr-1" /> {L("Hentikan & hantar apa yang ada", "Stop & send what's recorded")}</Button>
        </div>
      )}
    </div>
  );
};
